import React from 'react';
import { VerifiedVetIcon } from '@/icons/VerifiedVet';
import { RecommendedTickIcon } from '@/icons/RecommendationsTick';
import { Container } from '../Container';
import { Flex } from '../Flex';
import { Typography } from '../Typography';
import { PersonDetailsCard } from '../PersonDetailsCard/PersonDetailsCard';
import { theme } from '../../wag-react/themes/base-theme';

// Natural time format = server can return it on this format
export type ArticleAdviceAnswerValue = Record<'name' | 'url' | 'text' | 'dateLabel', string> & {
  numberOfRecommendations: number;
};
type Props = {
  value: ArticleAdviceAnswerValue;
};
export const ArticleAdviceAnswer = ({
  value: {
    name,
    url,
    text,
    numberOfRecommendations,
    dateLabel
  }
}: Props) => <Flex flexDirection="column" alignItems="center" borderY={`${theme.colors.whisper} 1px solid`} data-sentry-element="Flex" data-sentry-component="ArticleAdviceAnswer" data-sentry-source-file="index.tsx">
    <Container p="24px" data-sentry-element="Container" data-sentry-source-file="index.tsx">
      <PersonDetailsCard image={url} name={name} bio={`${numberOfRecommendations} Recommendations`} preName="Answered by" postName={<VerifiedVetIcon width="16px" height="16px" ml="6px" mb="2px" position="relative" top="3px" />} preBio={<RecommendedTickIcon width="16px" height="16px" mr="6px" mb="2px" />} data-sentry-element="PersonDetailsCard" data-sentry-source-file="index.tsx" />
      <Typography variant="body2" display="block" lineHeight="28px" my="16px" style={{
      wordBreak: 'break-word'
    }} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        {text}
      </Typography>
      <Typography fontSize="14px" opacity={0.5} my={0} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        {dateLabel}
      </Typography>
    </Container>
  </Flex>;
export type ArticleAdviceAnswerProps = Props;